import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router } from '@angular/router';
import { RoutesUtilsService } from '@vfde-fe/ngx-lib/services/routes-utils';

/** WhiteListDeepLinksGuard */
@Injectable(
  {
    providedIn: 'root',
  },
)
export class  WhiteListDeepLinksGuard implements CanActivate {

    public constructor (private router: Router,
        private routesUtilsService: RoutesUtilsService) { }
    /**
     * canActivate is checking if the use came from deeplink or not
     * if the use came from deeplink then we will navigate him to the fall back deep link
     * @param route - snapshot of current route data
     * @param state - snapshot of current state data
     * @returns {Observable<boolean>}
     */
    /** canActivate */
    public canActivate (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        if (window.location.href.indexOf(state.url.split('#')[0].split('?')[0]) >= 0) {
          if (!this.routesUtilsService.getbackButtonPressedFlag()) {

              const currentRoute = this.routesUtilsService.getRouteUsingURL(state.url.split('#')[0].split('?')[0]);
              if (currentRoute.fallbackDeeplinking) {
                  if (!currentRoute.fallbackDeeplinking.disableRefresh && performance.navigation.type === 1) {

                      return true;
                  } else {
                      const queryParams = document.referrer.split('#')[0].split('?').length;
                      this.routesUtilsService.navigateToURL(currentRoute.fallbackDeeplinking.url, true);

                          return false;
                  }
              }

              return true;
          }
      } else {
          return true;
      }

    }

}
